/**
 * Splits a comma-formatted property address into its street line and the remaining area
 * (suburb/city/postcode). Used wherever only the street should show — selectors, cards, loaders —
 * so the parsing rule lives in one place rather than being re-split at each call site.
 */
export const splitAddress = (address: string) => {
	const [street, ...rest] = address.split(',');
	return {
		street: street?.trim() || address,
		area: rest.join(',').trim(),
	};
};
